import { rgba } from 'polished';
import styled from 'styled-components';
import { Black3, Grey1, MangoBrightBlue, White } from '../../styles/colours';

export const StyledDatePickerPopUp = styled.div`
  z-index: 2;

  .CalendarMonthGrid_month__horizontal .CalendarMonth,
  .DayPicker_transitionContainer .CalendarMonthGrid,
  .DateRangePickerInput .DayPicker__horizontal,
  .DateRangePicker_picker,
  .DayPicker_transitionContainer__horizontal {
    background: ${White};
    border-radius: 5px;
  }

  .DayPicker .CalendarDay__default {
    background: ${Grey1};
    color: ${Black3};
    border-color: ${White};
    border-radius: 4px;
  }

  .DayPicker {
    margin: 0rem 1rem 0rem 0rem;
  }

  .DateRangePicker_picker {
    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.25);
  }

  .DayPicker__withBorder {
    box-shadow: none;
  }

  .DayPicker .CalendarDay__default:hover {
    background: ${MangoBrightBlue};
    border: inherit;
  }

  .DayPicker .CalendarMonth_caption {
    color: ${Black3};
  }

  .DayPicker .CalendarDay__selected {
    background: ${MangoBrightBlue};
  }

  .DateRangePicker .CalendarDay__selected_span,
  .DateRangePicker .CalendarDay__hovered_span:hover,
  .DateRangePicker .CalendarDay__hovered_span {
    background: ${rgba(MangoBrightBlue, 0.39)};
    color: ${Black3};
  }

  .DayPickerNavigation .DayPickerNavigation_button {
    background: transparent;
    border-radius: 0;
  }

  .DayPickerKeyboardShortcuts_show__bottomRight {
    display: none;
  }

  .CalendarMonth .CalendarMonth_table.CalendarMonth_table_1 {
    margin-top: 1.5rem;
  }

  .DayPicker_weekHeader .DayPicker_weekHeader_ul {
    border-top: 1px solid ${Grey1};
    font-size: 1rem;
    padding: 0.5rem 0;
  }

  .DayPicker .CalendarDay__selected_start,
  .DayPicker .CalendarDay__selected_start:hover {
    border-radius: 50% 0% 0% 50%;
  }

  .DayPicker .CalendarDay__selected_end,
  .DayPicker .CalendarDay__selected_end:hover,
  .DayPicker .CalendarDay__hovered_span:hover {
    border-radius: 0% 50% 50% 0%;
  }
`;
